function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1.33002 9.2151C1.33025 9.49459 1.41092 9.76811 1.56239 10.003C1.71387 10.2379 1.92974 10.4242 2.18424 10.5397C2.43875 10.6553 2.72112 10.6951 2.99764 10.6545C3.27417 10.6139 3.53316 10.4945 3.7437 10.3107L8.67252 5.99953L3.7437 1.6857C3.53329 1.50149 3.27425 1.38181 2.99759 1.34098C2.72093 1.30016 2.43837 1.33992 2.18372 1.45551C1.92907 1.57109 1.71312 1.75761 1.56172 1.99274C1.41032 2.22786 1.32987 2.50164 1.33002 2.78129V9.2151Z",
    stroke: props.fill,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};
export default SvgPlay;